/* Jane Lushka, 29 Oct 2026: the discount code field in the bag and on the bag page (snippets/jl-cart-discounts.liquid,
   mode 'field', and the Remove button on each code row). One code at a time: Apply sets the cart's code through
   /cart/update.js (discount), Remove clears it. The bag and the bag page are then re-rendered from the same response
   (the same two wrappers cart.js swaps), so the struck prices, the code row and the total follow at once.
   A code Shopify does not apply to this bag is taken off again and the field says so.
   Every listener is delegated from document (cart.js and cart-drawer.js re-render the field); the field's change
   events stop at document capture, so <cart-items> never reads them as a quantity change. */
(() => {
  if (window.jlCartCode) return;
  window.jlCartCode = true;

  const FIELD = '[data-jl-code]';

  const cartItemsEls = () =>
    Array.from(document.querySelectorAll('cart-items')).filter((el) => el.querySelector('#main-cart-items[data-id]'));

  const render = (state) => {
    if (!state.sections) return;
    cartItemsEls().forEach((el) => {
      const html = state.sections[el.querySelector('#main-cart-items').dataset.id];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      ['.js-cart-item-contents', '.js-cart-footer-contents'].forEach((sel) => {
        const from = doc.querySelector(sel);
        const to = el.querySelector(sel);
        if (from && to) to.innerHTML = from.innerHTML;
      });
    });
  };

  const setCode = (code) =>
    fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: code,
        sections: cartItemsEls().map((el) => el.querySelector('#main-cart-items').dataset.id),
        sections_url: window.location.pathname,
      }),
    }).then((r) => {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    });

  // After a re-render, the field in the same place (bag or bag page) as the one the shopper used
  const fieldIn = (host) => (host && host.querySelector(FIELD)) || document.querySelector(FIELD);

  const say = (field, text) => {
    if (!field) return;
    field.open = true;
    const msg = field.querySelector('[data-jl-code-msg]');
    if (msg) msg.textContent = text;
    field.querySelector('[data-jl-code-input]')?.focus();
  };

  const busy = (el, on) => {
    el?.querySelectorAll('button, input').forEach((b) => {
      if (on) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
      if (b.tagName === 'INPUT') b.readOnly = on;
    });
  };

  const apply = (field) => {
    const input = field.querySelector('[data-jl-code-input]');
    const code = (input?.value || '').trim();
    if (!code || field.dataset.busy) return;
    const host = field.closest('cart-items');
    const strings = { invalid: field.dataset.invalid, error: field.dataset.error };
    field.dataset.busy = '1';
    busy(field, true);
    setCode(code)
      .then((state) => {
        const hit = (state.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (hit && hit.applicable) {
          render(state);
          host?.querySelector('[data-jl-code-remove]')?.focus();
          return;
        }
        return setCode('').then((cleared) => {
          render(cleared);
          const next = fieldIn(host);
          const nextInput = next?.querySelector('[data-jl-code-input]');
          if (nextInput) nextInput.value = code;
          say(next, strings.invalid);
        });
      })
      .catch(() => say(fieldIn(host), strings.error))
      .finally(() => {
        delete field.dataset.busy;
        busy(field, false);
      });
  };

  const remove = (btn) => {
    if (btn.getAttribute('aria-disabled')) return;
    const host = btn.closest('cart-items');
    btn.setAttribute('aria-disabled', 'true');
    setCode('')
      .then((state) => {
        render(state);
        fieldIn(host)?.querySelector('summary')?.focus();
      })
      .catch(() => btn.removeAttribute('aria-disabled'));
  };

  document.addEventListener(
    'change',
    (e) => {
      if (e.target.closest && e.target.closest(FIELD)) e.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-jl-code-input]')) return;
      // Enter would submit the bag's form, and that form's first button is Checkout
      e.preventDefault();
      apply(e.target.closest(FIELD));
    },
    true
  );

  document.addEventListener('click', (e) => {
    const applyBtn = e.target.closest && e.target.closest('[data-jl-code-apply]');
    if (applyBtn) {
      e.preventDefault();
      apply(applyBtn.closest(FIELD));
      return;
    }
    const removeBtn = e.target.closest && e.target.closest('[data-jl-code-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn);
    }
  });
})();
